// extracted by mini-css-extract-plugin
export default {"card":"UiDrawerOrgLogo_card__RKYgp","logo":"UiDrawerOrgLogo_logo__bUFJB","logoContainer":"UiDrawerOrgLogo_logoContainer__ef18i"};